var show = console.log.bind( console );

export class Util {

      static months = [4,6,9,11];

      public static isValidDateStr(theDate:string):boolean {
          
            if ( !theDate ) return true;
            
            let  values = theDate.split("-");

            if ( values.length == 3 ) {
                 let yy = Number(values[0]);
                 let mm = Number(values[1]);
                 let dd = Number(values[2]);
                 
                 if ( yy < 1000 ) return false;
                 
                 if ( mm && dd ) return Util._isValidDate(mm,dd,yy);
            }
            return false;
      }

      // this is only for internal purpose : don't use it.
      public static _isValidDate(mm,dd,yy):boolean {
            
            if ( mm && dd ) {
                  if ( this.months.indexOf(mm) >= 0  ) {
                       if ( dd >= 31 ) return false;
                  }
                  else
                  if ( mm == 2 ) {
                       let dayMax = 29;
                       if ( yy && yy%4 != 0 )  dayMax = 28;
                  
                       if ( dd > dayMax ) return false;
                  }
                  else
                  if ( mm > 12 ) return false;
            }            
            return true;
      }

      /*
       *  @return  0:  GOOD
       *          -1:  one year or more older
       *           1:  Future date.
       */
      public static FUTURE_DATE:number   = -1;
      public static ONE_YEAR_MORE:number =  1;
      public static INVALID_DATE:number  = -4;
      public static EMPTY_DATE:number    = -2;

      public static isEligible(theDate:string):number {

            if ( Util.isEmpty(theDate) ) return Util.EMPTY_DATE;

            let  values = theDate.split("-");
            if ( values.length == 3 ) {
                 let yy = Number(values[0]);
                 let mm = Number(values[1]);
                 let dd = Number(values[2]);

                 if ( yy < 1000 || !mm || !dd ) return Util.INVALID_DATE;

                 var today = new Date();
                 let curDD:number = today.getDate();
                 let curMM:number = today.getMonth() + 1;
                 let curYY:number = today.getFullYear();                 
                 
                 if ( yy >  curYY ) return Util.FUTURE_DATE;
                 if ( yy == curYY ) {
                      if ( mm > curMM ) return Util.FUTURE_DATE;
                      if ( mm < curMM ) return  0;
                      if ( dd > curDD ) return Util.FUTURE_DATE;
                                        return  0;
                 }
                 else 
                 if ( ++yy == curYY )
                 {
                      if ( mm < curMM ) return Util.ONE_YEAR_MORE;
                      if ( mm > curMM ) return 0;
                      if ( dd > curDD ) return 0;
                      return Util.ONE_YEAR_MORE;
                 }
                 else return Util.ONE_YEAR_MORE;
            }

            return Util.INVALID_DATE;
      }

      public static age(birthDay:string, baseDate?:string):number {

            if ( Util.isEmpty(birthDay) ) return null;

            let  values = birthDay.split("-");

            if ( values.length == 3 ) {
                 let yy = Number(values[0]);
                 let mm = Number(values[1]);
                 let dd = Number(values[2]);

                 if ( yy == 0 || mm == 0 || dd == 0 ) return null;

                 if ( yy < 1000 || mm  == 0 || dd == 0 || Util._isValidDate(mm,dd,yy) == false  ) {
                      return Util.INVALID_DATE;
                 }

                 let curDD:number;
                 let curMM:number;
                 let curYY:number;                 

                 if ( baseDate ) {
                      values = baseDate.split("-");
                      curYY = Number(values[0]);
                      curMM = Number(values[1]);
                      curDD = Number(values[2]);
                 }
                 else {
                      let today = new Date();
                      curDD = today.getDate();
                      curMM = today.getMonth() + 1;
                      curYY = today.getFullYear();                 
                 }

                 if ( yy > curYY ) return Util.FUTURE_DATE;

                 if ( yy == curYY ) {
                      if ( mm > curMM ) return Util.FUTURE_DATE;
                      if ( mm < curMM ) return  0;
                      if ( dd > curDD ) return Util.FUTURE_DATE;
                                        return  0;
                 }

                 let age:number = curYY - yy;

                 if ( mm > curMM ) age--;
                 if ( mm == curMM ) {
                      if ( dd > curDD ) age--;
                 }

                 return age;
            }

            return Util.INVALID_DATE;
      }

      public static hasSpecialCharacter(value:string):boolean {
             let    pattern:RegExp = /^.*[;%/\>\<\+\(\)\*\{\}\=\\].*$/;
             return pattern.test(value);
      }

      public static isValidName(value:string):boolean {
            let     pattern:RegExp = /^.*[;%/\>\<\+\(\)\*\{\}\=\\0-9].*$/;
            return !pattern.test(value);
      }
      
      public static emailValidate(value:string):boolean {
             let    pattern:RegExp = /^[\w-\.][\w-\.!#$%&'*+/=?^_‘{|}~]*@([\w-]+\.)+[\w-]{2,4}$/;
             return pattern.test(value);
      }

      public static postalCodeValidate(value:string):boolean {
             let    pattern:RegExp = /^[ABCEGHJ-NPRSTVXYabceghj-nprstvxy][0-9][ABCEGHJ-NPRSTV-Zabceghj-nprstv-z] ?[0-9][ABCEGHJ-NPRSTV-Zabceghj-nprstv-z][0-9]$/;
             return pattern.test(value);
      }

      public static postalCodeGlobalValidate(value:string):boolean {
            let    pattern1:RegExp = /^[a-zA-Z0-9]{1,10}[\\-]?[a-zA-Z0-9]{1,10}$/;
            let    pattern2:RegExp = /^[a-zA-Z]\\d[a-zA-Z]\\s*\\d[a-zA-Z]\\d\\s*$/;
            return pattern1.test(value) || pattern2.test(value);
      }

      public static isEmpty(value:any):boolean {
          
             if ( value ) {
                  if ( typeof value == "string" ) {
                       return !value.trim();
                  }
                  return false;
             }

             return true;
      }

      public static isEmptyNumber(value:number):boolean {
          
            if ( value ) {
                 return false;
            }
            if ( value == 0 ) return false;

            return true;
     }

     public static isNumeric(sinStr):boolean {
           
            return /^(\d+)$/.test(sinStr);
     }


      // this is for spec.ts (test)
      public static compare(value1:string,value2:string, propKey?:string):boolean {

            let holder1 = [];
            let holder2 = [];

            for ( let i = 0; i < value1.length; i++ ) {
                  let  chr = value1.charAt(i);
                  if ( chr > ' ' ) {
                       holder1.push(chr);
                  }
             }

            for ( let i = 0; i < value2.length; i++ ) {
                  let  chr = value2.charAt(i);
                  if ( chr > ' ' ) {
                       holder2.push(chr);
                  }
             }

             if ( holder1.length == holder2.length ) {
                  if ( holder1.join("") == holder2.join("") ) return true;
             }
             ///console.error("-----------["+propKey+"]-----------");
             ///console.log(value1);
             ///console.log(value2);
             return false;
      }

      public static concat(v1:number, v2?:number,v3?:number,v4?:number,v5?:number):string {
            
             let ans:string = String(v1||'');
             if ( arguments.length >= 2 ) ans += String(v2||''); else return ans;
             if ( arguments.length >= 3 ) ans += String(v3||''); else return ans;
             if ( arguments.length >= 4 ) ans += String(v4||''); else return ans;
                                          
             ans += String(v5||''); 
             return ans;
      }

      public static getToday() {
             
            var today = new Date();
            let curDD:number = today.getDate();
            let curMM:number = today.getMonth() + 1;
            let curYY:number = today.getFullYear();

            return curYY + Util.padZero(String(curMM),2) + Util.padZero(String(curDD),2);
      }

      /**
      static currIdx:number = 0;
      static urlList = new Array<String>();

      public static urlChange(url:string) {
             if ( url == "/" ) url = "/start";
             let idx = Util.urlList.indexOf(url);  
             if ( idx < 0 ) { 
                  Util.urlList.push(url);
                  Util.currIdx = Util.urlList.length;
             }
             else {
                   Util.currIdx = idx+1;
             }
      }

      public static currentPageIndex():number {
             return Util.currIdx;
      }
       */

      static ZEROS:string = "00000000000000000000";
      public static padZero(value:string, len:number):string {
             if ( value ) {
                  let vLen = value.length;
                  if ( vLen < len ) {
                       value = Util.ZEROS.substring(0,len-vLen) + value;
                  }
             }
             return value;
      }

      public static trim(value:string):string {
             return value.trim().replace(/\s\s+/g, ' ');
      }


      public static hasAccentChar(value: string): boolean {
          let accentChars = ['â', 'à', 'ç', 'é', 'ê', 'ë', 'è', 'ï', 'î', 'ô', 'û', 'ù'];

          for(let i = 0; i < value.length; i++){
               if(accentChars.indexOf(value.charAt(i).toLowerCase()) > -1){
                    return true;
               }
          }

          return false;
      }
}

